module.exports = __webpack_public_path__ + "static/media/ni.a03b3380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ni.png
// module id = 1943
// module chunks = 0